// class AmapMarker {

// }

const geoEditor = () => {
  const addMarker = (AMap, amap, layer) => {
    return (point, { onClick, onDragend }) => {
      console.log('[2]', point)
      amap.clearMap()

      const marker = new AMap.Marker({
        map: amap,
        position: point.lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: point.address,
        draggable: true,
        raiseOnDrag: true,
        // content: point.content,
      })
      marker.on('click', (e) => {
        // console.log('[3]', e)
        onClick(e)
        const markerInfoWindow = new AMap.InfoWindow()
        markerInfoWindow.setContent(point.content)
        markerInfoWindow.open(amap, e.lnglat)
      })
      marker.on('dragend', (e) => {
        console.log('[4]', e)
        onDragend(e)
        // const markerInfoWindow = new AMap.InfoWindow()
        // markerInfoWindow.setContent(point.content)
        // markerInfoWindow.open(amap, e.lnglat)
      })
      amap.setCenter(point.lnglat)
    }
  }

  const init = (AMap, amap, layer) => {
    // layer.addMarker = addMarker(AMap, amap, layer)
  }

  const setApis = (AMap, amap) => {
    return {
      initMarker: (layer, extFunc) => {
        layer.addMarker = addMarker(AMap, amap, layer)
      },
    }
  }

  return {
    amapPlugins: [],
    init,
    setApis,
  }
}

export default geoEditor
